import React, { useState, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import AuthContext from '../../../contexts/auth';
import { setValueSearchFilter, setPage, translate } from '../../../utils/Common';
import { useForm } from 'react-hook-form';
import * as BsIcons from 'react-icons/bs';
import PageContainer from '../../../components/layout/PageContainer';
import PageHeader from '../../../components/layout/PageHeader';
import ContentCard from '../../../components/layout/ContentCard';
import PackagesReservation from '../../../components/PackagesReservation';
import ItemReserva from '../../../components/ShowItems/ItemReserva';
import ProviderList from '../../../components/ProviderList';
import { verifyAccessViewPermissions } from '../../../config/permissions';
import styles from './Reservations.module.css';

const Reservation = () => {
    const location = useLocation();
    const { register, watch, setValue } = useForm();
    const provider = useRef({});
    provider.current = watch('proveedor', '');
    const userContext = useContext(AuthContext);
    const canSearch = verifyAccessViewPermissions(["search"], { path: location.pathname });
    
    
    // update table
    const [updateTable, setUpdateTable] = useState(false);
    
    // para obtener los proveedores
    const [selectedUser, setSelectedUser] = useState(null);

    // Seleccionar Empresa
    const [selectedCompany, setSelectedCompany] = useState(null);
  
    useEffect(() => {
        const handleUserChange = () => {
            setSelectedUser(selectedCompany ? Number(selectedCompany.IdUsuario) : 0);
            setUpdateTable(!updateTable);            
        }
        handleUserChange();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provider.current, selectedCompany ])

    useEffect(() => {
        setPage('')
        setValueSearchFilter('');
    }, []);

    return (
        <PageContainer>
            <PageHeader
                title={translate("dashboard.lockers.reservations.title")}
                icon={<BsIcons.BsInboxesFill size={20} />}
            />

            {userContext.user?.IsAdmin && canSearch && (
              <ContentCard padding="md">
                <div className={styles.filterRow}>
                  <div className={styles.filterField}>
                    <label htmlFor="selectProveedor" className={styles.filterLabel}>
                      <span className={styles.requiredMark}>*</span>
                      {translate("global.business")}:
                    </label>
                    <ProviderList
                      register={register}
                      nameShow={translate("global.select")}
                      idShow={"all"}
                      readOnly={false}
                      setValue={setValue}
                      valueId={"proveedor"}
                      setProveedor={setSelectedCompany}
                    />
                  </div>
                </div>
              </ContentCard>
            )}

            <PackagesReservation
                selectedUser={selectedUser}
                updateTable={updateTable}
                handleUpdateTable={setUpdateTable}
                ItemComponent={ItemReserva}
                reservationType={1}
                canSearchCompany={canSearch}
            />
        </PageContainer>
    );
}

export default Reservation;